import { motion } from 'framer-motion';

import { SEGMENT_ANIMATION } from '@/components/WheelOfFortune/WheelOfFortune/animations';
import { WHEEL_SEGMENTS } from '@/components/WheelOfFortune/WheelOfFortune/constants';
import {
  createSegmentPath,
  calculateSegmentAngles,
  calculateTextPosition,
} from '@/components/WheelOfFortune/WheelOfFortune/utils';

type SegmentProps = {
  id: string;
  index: number;
  color: string;
  prize: string;
};

const Segment = ({ id, index, color, prize }: SegmentProps) => {
  const { startAngle, endAngle } = calculateSegmentAngles(
    index,
    WHEEL_SEGMENTS
  );
  const path = createSegmentPath(startAngle, endAngle, 180);

  const { textX, textY, textAngle } = calculateTextPosition(
    startAngle,
    endAngle
  );

  return (
    <motion.g
      key={id}
      {...SEGMENT_ANIMATION}
      transition={SEGMENT_ANIMATION.transition(index)}
    >
      <motion.path d={path} fill={color} stroke="#fff" strokeWidth="2" />
      {/* Prize text - this can't be Typography because it needs to be rotated */}
      <text
        x={textX}
        y={textY}
        textAnchor="middle"
        dominantBaseline="middle"
        fill="white"
        fontSize="18"
        fontWeight="bold"
        style={{ pointerEvents: 'none' }}
        transform={`rotate(${textAngle}, ${textX}, ${textY})`}
      >
        {prize}
      </text>
    </motion.g>
  );
};

export default Segment;
